export class GitHubError extends Error {
    status;
    constructor(message, status) {
        super(message);
        this.name = "GitHubError";
        this.status = status;
    }
}
export class GitHubAuthError extends GitHubError {
    constructor(message = "GitHub authentication failed") {
        super(message, 401);
        this.name = "GitHubAuthError";
    }
}
export class GitHubConflictError extends GitHubError {
    path;
    constructor(path, status = 409) {
        super(`conflict writing ${path}`, status);
        this.name = "GitHubConflictError";
        this.path = path;
    }
}
export class GitHubNotFoundError extends GitHubError {
    path;
    constructor(path) {
        super(`not found: ${path}`, 404);
        this.name = "GitHubNotFoundError";
        this.path = path;
    }
}
//# sourceMappingURL=errors.js.map